import React, { useState, ReactNode, useRef, useEffect } from "react";

export interface AccordionV2Props {
  title: string;
  children: ReactNode;
  openAccordion: Boolean;
  borderRadius: string;
  style:string;
  customClassName:string;
  disableScroll?: boolean;
  className?: string;
  key?: string;
}

export function AccordionV2({ title, children, openAccordion, borderRadius,style,customClassName,disableScroll=false,className,key}: AccordionV2Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [contentHeight, setContentHeight] = useState<number>(0);
  const contentRef = useRef(null);
  
  useEffect(()=>{
    setIsOpen(openAccordion);
  },[])

  // Function to calculate and set the content height
  useEffect(() => {
    const calculateContentHeight = () => {
      if (contentRef.current) {
        const height = contentRef.current.clientHeight;
        setContentHeight(height);
      }
    };

    calculateContentHeight();

    window.addEventListener('resize', calculateContentHeight);

    return () => {
      window.removeEventListener('resize', calculateContentHeight);
    };
  }, [isOpen]);

  return (
    <div  className={`${isOpen ? customClassName : ""} ${className}`}id="accordion-collapse" data-accordion="collapse" key={key}>
      <button
        type="button"
        className={`flex items-center justify-between w-full py-[13px] px-2 text-left `}
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        name="accordianExpandClose"
      >
        <div className={`${style ? "flex items-center w-full justify-between font-medium text-lg h-2 " : "flex items-center w-full justify-between font-medium text-sm"}`}>
          <span className={`${ style? "font-semibold text-typography-primary align-middle text-xl ml-4 mt-1 -mb-1 " : " "}`}>{title}</span>
          <svg
            className={`w-3 h-3 mr-0 shrink-0 ${!isOpen ? "rotate-180" : ""}`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" color="#333333" d="M9 5 5 1 1 5" />
          </svg>
        </div>
      </button>
      {isOpen && (
        <div
        ref={contentRef}
        className={`${isOpen ? "block" : "hidden"}
        max-h-[250px] ${disableScroll ?  " max-h-full overflow-hidden" : (250 <= contentHeight ? "max-h-full" : "")} ${borderRadius ? borderRadius : "rounded-akasa-default"} ${style ? style : ""} px-3 my-4 !-mt-1`}
        >
          {children}
        </div>
      )}
    </div>
  );
}
